import type { ImportMeta } from "../env";

const gmaps_api_key = process.env['VITE_GMAPS_API_KEY'] ||
  (import.meta as ImportMeta).env['VITE_GMAPS_API_KEY'];
const mailgun_smtp_user = process.env['VITE_MAILGUN_SMTP_USER'] ||
  (import.meta as ImportMeta).env['VITE_MAILGUN_SMTP_USER'];
const mailgun_pass = process.env['VITE_MAILGUN_PASS'] ||
  (import.meta as ImportMeta).env['VITE_MAILGUN_PASS'];
const mailgun_domain = process.env['VITE_MAILGUN_DOMAIN'] ||
  (import.meta as ImportMeta).env['VITE_MAILGUN_DOMAIN'];
const mailgun_api_key = process.env['VITE_MAILGUN_API_KEY'] ||
  (import.meta as ImportMeta).env['VITE_MAILGUN_API_KEY'];
const mailgun_api_user = process.env['VITE_MAILGUN_API_USER'] ||
  (import.meta as ImportMeta).env['VITE_MAILGUN_API_USER'];
const owner_emails = process.env['VITE_OWNER_EMAILS'] ||
  (import.meta as ImportMeta).env['VITE_OWNER_EMAILS'];
const owners = Array.isArray(owner_emails) ? owner_emails : [owner_emails];

if (process.env.NODE_ENV !== 'production') {
  console.log(`Config loaded:
  gmaps_api_key: ${gmaps_api_key}
  mailgun_smtp_user: ${mailgun_smtp_user}
  mailgun_pass: ${mailgun_pass}
  mailgun_domain: ${mailgun_domain}
  mailgun_api_key: ${mailgun_api_key}
  mailgun_api_user: ${mailgun_api_user}
  owner_emails: ${owner_emails}`);
}
export const Config = {
  gmaps_api_key,
  mailgun_smtp_user,
  mailgun_pass,
  mailgun_domain,
  mailgun_api_key,
  mailgun_api_user,
  owner_emails: owners
};
